<template>
  <InfoCard
    v-if="pricesCount > 0"
    :subtitle="`${numberFormatter.format(pricesCount)} ${tStatic('цены на услуги')}`"
    icon="ui-icon-ruble1"
    @click="handleClickPrices"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useURLStore from 'src/store/useURLStore'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import InfoCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/InfoCard.vue'

const props = defineProps<{
  lpu: Lpu
  synonymPricesCount?: number
}>()

const { reverseFull } = useURLStore()
const numberFormatter = new Intl.NumberFormat('ru-RU')
const pricesCount = computed(() => props.synonymPricesCount || props.lpu.number_of_prices || 0)

const lpuPriceUrl = reverseFull({
  name: 'lpu_price',
  args: [
    props.lpu.town.translit,
    props.lpu.translit,
  ],
})

function handleClickPrices() {
  window.location.assign(`${lpuPriceUrl}#prices`)
}
</script>
